(function () {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function captureUtm() {
    const params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(function (key) {
      if (params.get(key)) {
        localStorage.setItem(key, params.get(key));
      }
    });
  }

  function fillUtmFields() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      UTM_KEYS.forEach(function (key) {
        var existing = form.querySelector('[name="contact[' + key + ']"]');
        if (!existing) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[' + key + ']';
          input.value = localStorage.getItem(key) || '';
          form.appendChild(input);
        } else {
          existing.value = localStorage.getItem(key) || '';
        }
      });
    });
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.includes('/contact')) {
      fillUtmFields();
    }
  }, true);

  captureUtm();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillUtmFields);
  } else {
    fillUtmFields();
  }
})();
